import * as Raven from 'raven-js';
import { convertAnyToError } from './errorReporting.shared';
export default (error, extra = {}) => Raven.captureException(convertAnyToError(error), {
    extra
});
//# sourceMappingURL=errorReporting.browser.js.map